// npm packages
import React from 'react';
import { cn } from '@/utils/cn';

// className="px-15 sm:px-[30px] md:px-[60px] xl:px-[80px] 2xl:px-[100px] 3xl:px-0"

function Container({ children, className = '' }) {
  return (
    <div className={cn(`container mx-auto  ${className}`)}>{children}</div>
  );
}

export default Container;
